import { useEffect, useState } from "react";
import { MessageBalloon } from "../../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../../assets/svg/icons/point.svg";
import { ReactComponent as GrassIcon } from "../../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../../Buttons/ButtonPressed";

interface InfoStripMovementProps {
  task: ITaskStripMovement | undefined;
}

export default function InfoStripMovement(task: InfoStripMovementProps) {
  const [taskCollect, setTaskCollect] = useState<ITaskStripMovement>();
  useEffect(() => {
    setTaskCollect(task.task)
  }, []);


  const mapText = new Map();
  mapText.set("FULL", "Cheio")
  mapText.set("EMPTY", "Vazio")
  mapText.set("MEDIUM", "Médio")

  return (
    <>
      <div >
        <span>No pasto</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskCollect?.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`Confirme a movimentação de faixa`} pointed />
      </div>

      <ButtonPressed onlyResult optionSelected={1} value={1} text={`CONFIRMADO`} />
    </>
  )
}